import { Link } from "react-router-dom";
import { Phone, Smartphone, Mail, MapPin } from "lucide-react";
import { useLang } from "../i18n/LanguageContext";
import { ASSETS, LINKS } from "../lib/assets";

export const Footer = () => {
  const { t } = useLang();
  const links = [
    { to: "/", label: t.nav.home },
    { to: "/about", label: t.nav.about },
    { to: "/academics", label: t.nav.academics },
    { to: "/contact", label: t.nav.contact },
  ];

  return (
    <footer className="bg-navy-deep text-ivory" data-testid="site-footer">
      <div className="mx-auto max-w-7xl px-5 pb-28 pt-20 sm:px-8 lg:pb-20">
        <div className="grid gap-14 lg:grid-cols-12">
          <div className="lg:col-span-5">
            <div className="flex items-start gap-4">
              <img src={ASSETS.logo} alt="SMHSS crest" className="h-16 w-auto" />
              <div>
                <p className="font-heading text-2xl font-semibold leading-snug">{t.common.schoolName}</p>
                <p className="mt-2 text-sm uppercase tracking-[0.3em] text-gold">{t.common.motto}</p>
              </div>
            </div>
            <p className="mt-6 max-w-md text-sm font-light leading-relaxed text-ivory/70">{t.footer.tagline}</p>
          </div>

          <div className="lg:col-span-3">
            <p className="text-xs uppercase tracking-[0.25em] text-gold">{t.footer.quickLinks}</p>
            <span className="mt-3 block h-px w-10 bg-gold/50" />
            <nav className="mt-6 flex flex-col gap-3">
              {links.map((l) => (
                <Link
                  key={l.to}
                  to={l.to}
                  data-testid={`footer-link-${l.to === "/" ? "home" : l.to.slice(1)}`}
                  className="w-fit text-sm text-ivory/80 transition-colors duration-300 hover:text-gold"
                >
                  {l.label}
                </Link>
              ))}
            </nav>
          </div>

          <div className="lg:col-span-4">
            <p className="text-xs uppercase tracking-[0.25em] text-gold">{t.footer.contactTitle}</p>
            <span className="mt-3 block h-px w-10 bg-gold/50" />
            <div className="mt-6 space-y-4 text-sm text-ivory/80">
              <p className="flex items-start gap-3 font-light leading-relaxed">
                <MapPin size={16} className="mt-0.5 shrink-0 text-gold" />
                <span>
                  {t.common.addressLines[0]}
                  <br />
                  {t.common.addressLines[1]}
                </span>
              </p>
              <a href={LINKS.tel} data-testid="footer-tel" className="flex items-center gap-3 transition-colors duration-300 hover:text-gold">
                <Phone size={16} className="text-gold" /> 044 2486 7105
              </a>
              <a href={LINKS.mobile} data-testid="footer-mobile" className="flex items-center gap-3 transition-colors duration-300 hover:text-gold">
                <Smartphone size={16} className="text-gold" /> +91 76048 38880
              </a>
              <a href={LINKS.email} data-testid="footer-email" className="flex items-center gap-3 transition-colors duration-300 hover:text-gold">
                <Mail size={16} className="text-gold" /> sathyaschool1989@gmail.com
              </a>
            </div>
          </div>
        </div>

        <div className="mt-16 flex flex-col items-start justify-between gap-4 border-t border-ivory/10 pt-8 text-xs text-ivory/50 sm:flex-row sm:items-center">
          <p>
            {t.common.society} · {t.common.regd}
          </p>
          <p>
            © {new Date().getFullYear()} {t.common.schoolShort}. {t.footer.rights}
          </p>
        </div>
      </div>
    </footer>
  );
};
